angular.module('iqxCore')
.filter('contactsonly', [ function() {
    return function (object) {
        var array = [];
        angular.forEach(object, function (shift) {
            if (shift.VacType == 'CV')
                array.push(shift);
        });
        return array;
    };
}])